import { CLASSIFICATIONS_PREFIX } from '../../classifications/classification-filter.utils';
import { expandLegacyPreOrderFilter } from '../../products/utils/availability.utils';

export const CATALOG_LIST_FILTERS_KEYS = {
  query: 'query',
  status: 'status',
  isDefault: 'isDefault',
  isDynamic: 'isDynamic',
  isPublicLink: 'isPublicLink',
  startDate: 'startDate',
  endDate: 'endDate',
  customerIds: 'customerIds',
  salesRepresentativeIds: 'salesRepresentativeIds',
  classificationPermissionIds: 'classificationPermissionIds',
  productIds: 'productIds',
  categoryIds: 'categoryIds',
  collectionIds: 'collectionIds',
  colorIds: 'colorIds',
  deliveryWindowIds: 'deliveryWindowIds',
  availability: 'availability',
  hasPromotion: 'hasPromotion',
  isKit: 'isKit',
  classificationIds: 'classificationIds',
} as const;

export const formatCatalogListFilters = (filters: Record<string, any> = {}) => {
  const entries = Object.entries(filters);

  const classificationIds = entries
    .filter(([key]) => key.startsWith(CLASSIFICATIONS_PREFIX))
    .map(([, value]) => value)
    .flat(2);

  const cleanedFilters = Object.fromEntries(
    entries.map(([key, value]) => [
      key,
      key.startsWith(CLASSIFICATIONS_PREFIX) ? undefined : value,
    ]),
  );

  const availability = expandLegacyPreOrderFilter(
    cleanedFilters[CATALOG_LIST_FILTERS_KEYS.availability],
  );

  return {
    ...cleanedFilters,
    ...(availability && { [CATALOG_LIST_FILTERS_KEYS.availability]: availability }),
    [CATALOG_LIST_FILTERS_KEYS.classificationIds]: classificationIds,
  };
};
